import React, { FC } from "react";
import "./Calendar.css";
import Calendar from "react-calendar";

interface ICalendarProps {
  minDate: Date;
  maxDate: Date;
  value: Date;
  onChange: () => void;
}

const CustomCalendar: FC<ICalendarProps> = ({
  minDate,
  maxDate,
  value,
  onChange,
}) => {
  return (
    <Calendar
      className="react_calendar"
      locale="it"
      minDate={minDate}
      maxDate={maxDate}
      value={value}
      onChange={onChange}
      tileDisabled={({ activeStartDate, date, view }) => date.getDay() <= 1}
    />
  );
};

export default CustomCalendar;
